import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { AppBar, createStyles, FormControl, FormControlLabel, Grid, MenuItem, Select, TextField, Theme, Toolbar, Typography, withStyles, WithStyles } from '@material-ui/core';
import React from 'react';
import { DeltaXMLColors } from './styling/DeltaColors';

const styles = (theme: Theme) =>
  createStyles({
    hostForm: {
      backgroundColor: DeltaXMLColors.CONCRETE,
      borderRadius: 5,
      margin: theme.spacing(1),
      minWidth: 125,
    },
    appBar: {
      alignItems: "left",
      backgroundColor: DeltaXMLColors.OXFORD_BLUE,
    },
    heading: {
      color: DeltaXMLColors.CELERY,
    },
    extensionTextField: {
      borderRadius: 5,
      margin: theme.spacing(1),
      minWidth: 260
    },
    select: {
      marginLeft: '5px',
      marginRight: '5px'
    },
  });

  export interface ExtendLicenseDialogProps extends WithStyles<typeof styles> {
    dialogOpen: boolean;
    handleExtendLicenseClose: () => void;
  }

  function ExtendLicenseDialog(props: ExtendLicenseDialogProps) {
    const {classes, dialogOpen, handleExtendLicenseClose} = props;
    const [extensionPeriod, setExtensionPeriod] = React.useState('');
    const [extensionReason, setExtensionReason] = React.useState('');
    const [formValid, setFormValid] = React.useState(false);
    const [errorText, setErrorText] = React.useState("Select Extension Period")

    const handleExtensionPeriodChange = (event: React.ChangeEvent<{ value: unknown }>) => {
      setExtensionPeriod(event.target.value as string);
      if (event.target.value === "") {
        setErrorText("Select Extension Period");
        setFormValid(false);
      } else if(extensionReason !== ""){
        setErrorText("");
        setFormValid(true);
      } else {
        setErrorText("Enter Extension Reason");
        setFormValid(false);
      }
    }

    const handleExtensionReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setExtensionReason(event.target.value as string);
      if (event.target.value === "") {
        setErrorText("Enter Extension Reason");
        setFormValid(false);
      } else if(extensionPeriod !== "") {
        setErrorText("");
        setFormValid(true);
      } else {
        setErrorText("Select Extension Period");
        setFormValid(false);
      }
    }

    return (
        <Dialog open={dialogOpen} onClose={handleExtendLicenseClose}>
          <AppBar className={classes.appBar} position="static">
            <Toolbar>
              <Typography variant="h4">Extend License</Typography>
            </Toolbar>
          </AppBar>
          <br />
          <DialogContent>
          <Grid container>
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <FormControl className={classes.hostForm}>
                    <Select 
                      className={classes.select}
                      value={extensionPeriod}
                      onChange={handleExtensionPeriodChange}
                    >
                      <MenuItem value={1}>1 Day</MenuItem>
                      <MenuItem value={7}>7 Days</MenuItem>
                      <MenuItem value={30}>30 Days</MenuItem>
                    </Select>
                  </FormControl>
                }
                label="Extension Period"
                labelPlacement="top"
              />
            </Grid>
            <Grid item xs={8}>
              <FormControlLabel
                control={<TextField multiline={true} rows={4} variant="outlined" className={classes.extensionTextField} helperText={errorText ? errorText : " "} error={!(formValid)} value={extensionReason} onChange={handleExtensionReasonChange}/>}
                label="Extension Reason"
                labelPlacement="top"
              />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <a style={{ textDecoration: 'none'}} href={encodeURI("mailto:evaluator.support@deltaxml.atlassian.net?subject=License Extension Request&body=Extension Period: " + extensionPeriod + " Days \n\nExtension Reason: " + extensionReason)}><Button variant="contained" color="primary" onClick={handleExtendLicenseClose} disabled={!(formValid)}>Confirm</Button></a>
            <Button variant="contained" color="primary" onClick={handleExtendLicenseClose}>Cancel</Button>
          </DialogActions>
        </Dialog>
      ); 
  }

  export default withStyles(styles)(ExtendLicenseDialog);